<section class="pt-5 pb-5">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h3 class="mb-3">Stride Listings</h3>
            </div>
            <ng-container *ngFor="let listing of listings.slice(0,5)">
                <div class="col-md-4 pb-3">
                    <div
                        id="carouselExampleIndicators"
                        class="carousel slide"
                        data-ride="carousel"
                    >
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <img
                                    class="d-block w-100 listing-img"
                                    src="{{ listing.photos[1] }}"
                                    alt="First slide"
                                />
                                <div class="carousel-caption d-md-block">
                                    <div class="listing-details">
                                        <h5>
                                            {{
                                                getPrice(listing.listPrice)
                                            }}
                                        </h5>
                                        <p>
                                            {{
                                                listing.address.full +
                                                    ", " +
                                                    listing.address.city +
                                                    ", " +
                                                    listing.address.state
                                            }}
                                        </p>
                                        <p class="room_details">
                                            {{
                                                listing.property.bedrooms
                                            }}
                                            bds |
                                            {{
                                                listing.property.bathrooms
                                            }}
                                            bths |
                                            {{ listing.property.area }} sqft
                                        </p>
                                        <p>
                                           <a [routerLink]="getListingPageID(listing.listingId)">More Details</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <div class="col-md-4">
                <div
                    id="carouselExampleIndicators"
                    class="carousel slide"
                    data-ride="carousel"
                >
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img
                                class="d-block w-100 listing-img"
                                src="../../../assets/images/neighborhood.jpg"
                                alt="First slide"
                            />
                            <div class="carousel-caption d-md-block view-more">
                                <div class="more-listings-text">
                                    <h5>
                                        <a class="nav-link" [routerLink]="listingspage">View All Listings</a>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
